import { GET_USER_CART, ADD_SHOP, DEL_SHOP, REMOVE_ALL_SHOP, CALCULATE_PRICE, REQUEST_ERROR} from './visibility';
import {isJSON,cardGoodMergeArray} from '../../utils/util';
import initialState from './state';

let defualCartGoodsList = localStorage.getItem('recommendations_cart_fetched_with_prod')?localStorage.getItem('recommendations_cart_fetched_with_prod'):[];
if(isJSON(defualCartGoodsList)){
    initialState.cartGoodsList = JSON.parse(defualCartGoodsList)
}

// let defualCartGoodsPrice = localStorage.getItem('cart_goods_price')?localStorage.getItem('cart_goods_price'):'';
// if(isJSON(defualCartGoodsPrice)){
//     initialState.cartPriceSum = JSON.parse(defualCartGoodsPrice)
// }

let reducer=(state = initialState, action)=>{
    switch(action.type) {
        case GET_USER_CART:
            if(localStorage.getItem("auth_token")){
                localStorage.setItem("recommendations_cart_fetched_with_prod", JSON.stringify(action.payload));
                return {...state,  cartGoodsList: cardGoodMergeArray(action.payload, state.cartGoodsList)};
                // if(action.isOneSignIn){
                //     return {...state,  cartGoodsList: cardGoodMergeArray(state.cartGoodsList, action.payload)};
                // }else{
                //     return {...state,  cartGoodsList: action.payload };
                // }
            }else{
                return state;
            }
        case ADD_SHOP:
            localStorage.setItem("recommendations_cart_fetched_with_prod", JSON.stringify(action.payload));
            return {...state,
                cartGoodsList: action.payload
            };
        case DEL_SHOP:
            localStorage.setItem("recommendations_cart_fetched_with_prod", JSON.stringify(action.payload));
            return {...state,
                cartGoodsList: action.payload
            };

        case REMOVE_ALL_SHOP:
            localStorage.setItem("recommendations_cart_fetched_with_prod", "");
            return {...state,
                cartGoodsList: []
            };
        case REQUEST_ERROR:
            return state;

        // case CALCULATE_PRICE:
        //     localStorage.setItem("cart_goods_price", JSON.stringify(action.payload));
        //     return {...state,
        //         cartPriceSum: action.payload
        //     }; 

        default:
            return state
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/cartReducers/reducer.js